/**
 * Teals Design System - Spacing Tokens
 *
 * Consistent spacing scale based on 4px base unit.
 */
// Base spacing unit
const BASE_UNIT = 4;
export const spacing = {
    0: '0',
    0.5: `${BASE_UNIT * 0.5}px`, // 2px
    1: `${BASE_UNIT}px`, // 4px
    1.5: `${BASE_UNIT * 1.5}px`, // 6px
    2: `${BASE_UNIT * 2}px`, // 8px
    2.5: `${BASE_UNIT * 2.5}px`, // 10px
    3: `${BASE_UNIT * 3}px`, // 12px
    3.5: `${BASE_UNIT * 3.5}px`, // 14px
    4: `${BASE_UNIT * 4}px`, // 16px
    5: `${BASE_UNIT * 5}px`, // 20px
    6: `${BASE_UNIT * 6}px`, // 24px
    7: `${BASE_UNIT * 7}px`, // 28px
    8: `${BASE_UNIT * 8}px`, // 32px
    9: `${BASE_UNIT * 9}px`, // 36px
    10: `${BASE_UNIT * 10}px`, // 40px
    11: `${BASE_UNIT * 11}px`, // 44px
    12: `${BASE_UNIT * 12}px`, // 48px
    14: `${BASE_UNIT * 14}px`, // 56px
    16: `${BASE_UNIT * 16}px`, // 64px
    20: `${BASE_UNIT * 20}px`, // 80px
    24: `${BASE_UNIT * 24}px`, // 96px
    28: `${BASE_UNIT * 28}px`, // 112px
    32: `${BASE_UNIT * 32}px`, // 128px
    36: `${BASE_UNIT * 36}px`, // 144px
    40: `${BASE_UNIT * 40}px`, // 160px
    44: `${BASE_UNIT * 44}px`, // 176px
    48: `${BASE_UNIT * 48}px`, // 192px
    52: `${BASE_UNIT * 52}px`, // 208px
    56: `${BASE_UNIT * 56}px`, // 224px
    60: `${BASE_UNIT * 60}px`, // 240px
    64: `${BASE_UNIT * 64}px`, // 256px
    72: `${BASE_UNIT * 72}px`, // 288px
    80: `${BASE_UNIT * 80}px`, // 320px
    96: `${BASE_UNIT * 96}px`, // 384px
};
// Semantic spacing for common use cases
export const semanticSpacing = {
    // Component internal padding
    componentPaddingXs: spacing[2], // 8px
    componentPaddingSm: spacing[3], // 12px
    componentPaddingMd: spacing[4], // 16px
    componentPaddingLg: spacing[6], // 24px
    componentPaddingXl: spacing[8], // 32px
    // Gap between elements
    gapXs: spacing[1], // 4px
    gapSm: spacing[2], // 8px
    gapMd: spacing[4], // 16px
    gapLg: spacing[6], // 24px
    gapXl: spacing[8], // 32px
    // Section spacing
    sectionSm: spacing[8], // 32px
    sectionMd: spacing[12], // 48px
    sectionLg: spacing[16], // 64px
    sectionXl: spacing[24], // 96px
    // Page margins
    pageMarginMobile: spacing[4], // 16px
    pageMarginTablet: spacing[6], // 24px
    pageMarginDesktop: spacing[8], // 32px
};
